import { render, staticRenderFns } from "./follow_record_add.vue?vue&type=template&id=5e208dcd&"
import script from "./follow_record_add.vue?vue&type=script&lang=js&"
export * from "./follow_record_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports